var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.results),function(result){return _c('div',{key:result.id},[(result.screenName)?_c('UserNewMessage',{attrs:{"user":result},on:{"selected":_vm.selected}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }